import { ReactComponent as Home } from '../../assets/custom/icons/home.svg';
import { ReactComponent as PropertyManagement } from '../../assets/custom/icons/propertyManagement.svg';
import { ReactComponent as Reports } from '../../assets/custom/icons/reports.svg';
import { ReactComponent as RoomsAndHardware } from '../../assets/custom/icons/hardware.svg';
import { ReactComponent as Database } from '../../assets/custom/icons/database.svg';
import { ReactComponent as AdvancedSettings } from '../../assets/custom/icons/settings_cog.svg';
import { ReactComponent as Logout } from '../../assets/custom/icons/sign_out.svg';
import { logout } from '../../data/actions';
import useStore from '@data/state/zustand';

function logMeOut() {
    logout();
}

function toggleMainViewButtons(mainViewType) {
    const uiStates = useStore.getState().uiStates.dashboard.showComponents;
    let temp = uiStates ? [...uiStates] : [];

    if (temp.includes('timeline')) {
        temp = temp?.filter((t) => t !== 'timeline');
    }
    if (temp.includes('tiles')) {
        temp = temp?.filter((t) => t !== 'tiles');
    }
    if (temp.includes('activity')) {
        temp = temp?.filter((t) => t !== 'activity');
    }
    if (temp.includes('occupancy')) {
        temp = temp?.filter((t) => t !== 'occupancy');
    }
    // --   OVO OVDJE PROMIJENITI JOPA_-----
    if (mainViewType === 'occupancy') {
        temp.push('sidebar_dailyInfo');
    }

    temp.push(mainViewType);
    useStore.getState().setNestedProperty(['uiStates', 'dashboard', 'showComponents'], temp);
    // setTimeout(() => {
    //     clearReservationsFilterFields();
    // }, 10);
}

const SideMenuOnPrem = {
    home: {
        id: 'home',
        permissionCheckName: '',
        featureFlags: [],
        fullLabel: 'Home',
        label: 'Home',
        icon: <Home />,
        items: null,
        link: '/?rooms',
        // whenClicked:()=>{toggleMainViewButtons("timeline")},
        whenClicked: () => {
            toggleMainViewButtons('tiles');
        },
        description:
            'Create dynamic accommodation price list and bind them to rooms. Beside accommodation, you can create price lists for minibar, goods and services.',
    },

    dashboard: {
        id: 'dashboard',
        permissionCheckName: 'dashboard',
        featureFlags: ['hwOnPrem'],
        fullLabel: 'Front desk',
        label: 'Rooms',
        icon: <PropertyManagement />,
        items: [
            {
                itemLabel: 'Room controllers',
                link: '/?rooms',
                permissionCheckName: 'dashboard_roomControllers',
                featureFlags: ['hwOnPrem'],
                whenClicked: () => {
                    toggleMainViewButtons('tiles');
                },
            },
            {
                itemLabel: 'Situation center',
                link: '/allRoomEvents',
                permissionCheckName: 'situationCenter',
                featureFlags: ['hwOnPrem'],
                whenClicked: () => {
                    toggleMainViewButtons('situationCenter');
                },
            },
        ],
        // link:"/",
        description: 'Everything for reception.',
    },

    dataFolders: {
        id: 'dataFolders',
        permissionCheckName: 'foldersPanel',
        featureFlags: ['hwOnPrem'],
        fullLabel: 'Database',
        label: 'Data',
        icon: <Database />,
        items: [
            {
                itemLabel: 'Users',
                link: '/users',
                permissionCheckName: 'foldersPanel_users',
                featureFlags: ['hwOnPrem'],
            },
            {
                itemLabel: 'Rooms',
                link: '/roomsAdministration',
                permissionCheckName: 'foldersPanel_rooms',
                featureFlags: ['hwOnPrem'],
            },
        ],
        description: 'Create all models needed in application.',
    },

    roomsAndHardware: {
        id: 'roomsAndHardware',
        permissionCheckName: 'roomsPanel',
        featureFlags: ['hwOnPrem'],
        fullLabel: 'Hardware',
        label: 'Rooms',
        icon: <RoomsAndHardware />,
        items: [
            {
                itemLabel: 'HW Router',
                link: '/srcProxies',
                permissionCheckName: 'roomsPanel_HWProxy',
                featureFlags: ['hwOnPrem'],
            },
            {
                itemLabel: 'Broadcast settings',
                link: '/SRCBroadcastMulticast',
                permissionCheckName: 'roomsPanel_HWProxy',
                featureFlags: ['hwOnPrem'],
            },
            {
                itemLabel: 'Controllers',
                link: '/smartRoomControllers',
                permissionCheckName: 'roomsPanel_controllers',
                featureFlags: ['hwOnPrem'],
            },
            {
                itemLabel: 'SRC templates',
                link: '/srcTemplates',
                permissionCheckName: 'roomsPanel_SRCTemplates',
                featureFlags: ['hwOnPrem'],
            },
            {
                itemLabel: 'Doors & rules',
                link: '/accessControl',
                permissionCheckName: 'roomsPanel_doorsAndRules',
                featureFlags: ['hwOnPrem'],
            },
            {
                itemLabel: 'Whitelists',
                link: '/whiteLists',
                permissionCheckName: 'roomsPanel_whitelists',
                featureFlags: ['hwOnPrem'],
            },
        ],
        description:
            'Create or update hotel rooms informations. Declare SRC proxyes and bind their controllers with designated room. Create predefined SRC configurations and download them to selected rooms.',
    },
    reports: {
        id: 'reports',
        permissionCheckName: 'reports',
        featureFlags: ['hwOnPrem'],
        fullLabel: 'Reports',
        label: 'Reports',
        icon: <Reports />,
        items: [
            {
                itemLabel: 'Access control report',
                link: '/report/accessControl',
                permissionCheckName: 'accessControlReportPanel',
                featureFlags: ['hwOnPrem'],
            },
        ],
        description: 'Setup language, company informations, currency and modems configuration. Manage API keys.',
    },

    advancedSettings: {
        id: 'advancedSettings',
        permissionCheckName: 'advancedSettingsPanel',
        featureFlags: ['hwOnPrem'],
        fullLabel: 'Config',
        label: 'Config',
        icon: <AdvancedSettings />,
        items: [
            {
                itemLabel: 'Settings',
                link: '/generalSettings',
                permissionCheckName: 'advancedSettingsPanel_settings',
                featureFlags: null,
            },
            {
                itemLabel: 'Licence',
                link: '/licence',
                permissionCheckName: 'licencePanel_licence',
                featureFlags: ['hwOnPrem'],
            },
            {
                itemLabel: 'Help and support',
                link: '/help',
                permissionCheckName: 'advancedSettingsPanel',
                featureFlags: ['hwOnPrem'],
            },
        ],
        description: 'Setup language, company informations, currency and modems configuration. Manage API keys.',
    },

    logout: {
        id: 'logout',
        permissionCheckName: '',
        featureFlags: [],
        fullLabel: 'Log Out',
        label: 'Log out',
        icon: <Logout />,
        whenClicked: () => {
            logMeOut();
        },
        // items: [],
        description: 'All business conclusions in one place.',
    },
};

export default SideMenuOnPrem;
